import image1 from "../assets/news1.webp";
import image2 from "../assets/news2.webp";
import image3 from "../assets/news3.webp";
import image4 from "../assets/news4.webp";

export const newsData = [
  {
    id: 1,
    img: [image1],
    date: "Fri Mar 24 2023",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
  },
  {
    id: 2,
    img: [image2],
    date: "Sun Feb 10 2023",
    title:
      "Saylani Welfare International Trust MOU Ceremony with Sunridge Foods Taqatwar Pakistan App.",
    details:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
  },
  {
    id: 3,
    img: [image3],
    date: "Sat Feb 24 2023",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 4,
    img: [image4],
    date: "Tue Apr 05 2023",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 5,
    img: [image4],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 6,
    img: [image4],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 7,
    img: [image4],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 8,
    img: [image4],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 9,
    img: [image1],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 10,
    img: [image2],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 11,
    img: [image3],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 12,
    img: [image4],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 13,
    img: [image1],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 14,
    img: [image2],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 15,
    img: [image4],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
  {
    id: 16,
    img: [image1],
    date: "2023-03-24",
    title:
      "MoU Signing between Saylani Welfare International Trust x Etimad Online Groceries - Pvt Ltd",
    details:
      "He also donated 800 blankets to Saylani Welfare as part of IBA's flood relief operations. The floods in Pakistan have been devastating for many families and communities. Saylani Welfare has been on the frontlines of providing relief to those affected.",
  },
];
